import { render, staticRenderFns } from "./Xifen.vue?vue&type=template&id=cf8c0fea"
import script from "./Xifen.vue?vue&type=script&lang=js"
export * from "./Xifen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports